import { useEffect, useMemo } from 'react'
import { useUnmount } from 'react-use'
import { Task } from '../../../../types'
import { useStorePlayer } from '../store'

interface Props {
  task: Task
}

export const useDataPosts = ({ task }: Props): void => {
  const { setData } = useStorePlayer()

  const posts = useMemo(() => {
    if (task?.posts?.totalCount && task?.posts?.notes?.length) {
      return task.posts.notes
    }
    return undefined
  }, [task])

  useEffect(() => {
    setData({
      posts
    })
  }, [posts, setData])

  useUnmount(() => {
    setData({
      posts: undefined
    })
  })
}
